import { fork, all } from "redux-saga/effects";

// dokumen kerjasama sagas
import dokumenKerjasamaSagaCreateDokumenKerjasama from "../reducers/dokumenKerjasama/dokumenKerjasama.saga.createDokumenKerjasama";
import dokumenKerjasamaSagaGetDokumenKerjasama from "../reducers/dokumenKerjasama/dokumenKerjasama.saga.getDokumenKerjasama";
import dokumenKerjasamaSagaGetDetailDokumenKerjasama from "../reducers/dokumenKerjasama/dokumenKerjasama.saga.getDetailDokumenKerjasama";
import dokumenKerjasamaSagaUpdateDokumenKerjasama from "../reducers/dokumenKerjasama/dokumenKerjasama.saga.updateDokumenKerjasama";

// monev sagas
import monevSagaGetMonev from "../reducers/monev/monev.saga.getMonev";
import monevSagaUpdateMonev from "../reducers/monev/monev.saga.saveMonev";
import monevSagaCreateMonev from "../reducers/monev/monev.saga.createMonev";
import monevSagaGetDokumen from "../reducers/monev/monev.saga.getDokumen";
import monevSagaGetDetail from "../reducers/monev/monev.saga.getDetail";

// bentuk kerjasama sagas
import bentukKerjasamaSagaGetBentukKerjasama from "../reducers/bentukKerjasama/bentukKerjasama.saga.getBentukKerjasama";
import bentukKerjasamaSagaCreateBentukKerjasama from "../reducers/bentukKerjasama/bentukKerjasama.saga.createBentukKerjasama";
import bentukKerjasamaSagaUpdateBentukKerjasama from "../reducers/bentukKerjasama/bentukKerjasama.saga.updateBentukKerjasama";
import bentukKerjasamaSagaGetDetailBentukKerjasama from "../reducers/bentukKerjasama/bentukKerjasama.saga.getDetailBentukKerjasama";

// jenis lembaga sagas
import jenisLembagaSagaGetJenisLembaga from "../reducers/jenisLembaga/jenisLembaga.saga.getJenisLembaga";
import jenisLembagaSagaCreateJenisLembaga from "../reducers/jenisLembaga/jenisLembaga.saga.createJenisLembaga";
import jenisLembagaSagaUpdateJenisLembaga from "../reducers/jenisLembaga/jenisLembaga.saga.updateJenisLembaga";
import jenisLembagaSagaGetDetailJenisLembaga from "../reducers/jenisLembaga/jenisLembaga.saga.getDetailJenisLembaga";

// jenis dokumen sagas
import jenisDokumenSagaGetJenisDokumen from "../reducers/jenisDokumen/jenisDokumen.saga.getJenisDokumen";
import jenisDokumenSagaUpdateJenisDokumen from "../reducers/jenisDokumen/jenisDokumen.saga.updateJenisDokumen";
import jenisDokumenSagaCreateJenisDokumen from "../reducers/jenisDokumen/jenisDokumen.saga.createJenisDokumen";
import jenisDokumenSagaGetDetailJenisDokumen from "../reducers/jenisDokumen/jenisDokumen.saga.getDetailJenisDokumen";

// status kerjasama sagas
import statusKerjasamaSagaGetStatusKerjasama from "../reducers/statusKerjasama/statusKerjasama.saga.getStatusKerjasama";
import statusKerjasamaSagaUpdateStatusKerjasama from "../reducers/statusKerjasama/statusKerjasama.saga.saveStatusKerjasama";
import statusKerjasamaSagaCreateStatusKerjasama from "../reducers/statusKerjasama/statusKerjasama.saga.createStatusKerjasama";
import statusKerjasamaSagaGetDetailStatusKerjasama from "../reducers/statusKerjasama/statusKerjasama.saga.getDetailStatusKerjasama";

// partner sagas
import partnerSagaGetPartner from "../reducers/partner/partner.saga.getPartner";
import partnerSagaUpdatePartner from "../reducers/partner/partner.saga.updatePartner";
import partnerSagaCreatePartner from "../reducers/partner/partner.saga.createPartner";
import partnerSagaGetDetailPartner from "../reducers/partner/partner.saga.getDetailPartner";

// user roles sagas
import userRoleSagaGetRoles from "../reducers/userRole/userRole.saga.getRoles";
import userRoleSagaSaveRole from "../reducers/userRole/userRole.saga.saveRole";
import userRoleSagaCreateRole from "../reducers/userRole/userRole.saga.createRole";
import userRoleSagaGetDetailRoles from "../reducers/userRole/userRole.saga.getDetailRoles";

// user sagas
import userSagaGetUser from "../reducers/user/user.saga.getUser";
import userSagaCreateUser from "../reducers/user/user.saga.createUser";
import userSagaUpdateUser from "../reducers/user/user.saga.updateUser";
import userSagaGetDetailUser from "../reducers/user/user.saga.getDetailUser";

// sagas for umn view
import negaraSagaGetNegara from "../reducers/negara/negara.saga.getNegara";
import employeeSagaGetEmployee from "../reducers/employee/employee.saga.getEmployee";
import departmentSagaGetDepartment from "../reducers/department/department.saga.getDepartment";

// authorization sagas
import authorizationSagaGetUser from "../reducers/authorization/authorization.saga.getUser";


export function* rootSaga() {
  // dokumen kerjasama sagas
  yield all([fork(dokumenKerjasamaSagaGetDokumenKerjasama)]);
  yield all([fork(dokumenKerjasamaSagaUpdateDokumenKerjasama)]);
  yield all([fork(dokumenKerjasamaSagaCreateDokumenKerjasama)]);
  yield all([fork(dokumenKerjasamaSagaGetDetailDokumenKerjasama)]);

  // monev sagas
  yield all([fork(monevSagaGetMonev)]);
  yield all([fork(monevSagaGetDetail)]);
  yield all([fork(monevSagaGetDokumen)]);
  yield all([fork(monevSagaUpdateMonev)]);
  yield all([fork(monevSagaCreateMonev)]);

  // bentuk kerjasama sagas
  yield all([fork(bentukKerjasamaSagaGetBentukKerjasama)]);
  yield all([fork(bentukKerjasamaSagaGetDetailBentukKerjasama)]);
  yield all([fork(bentukKerjasamaSagaCreateBentukKerjasama)]);
  yield all([fork(bentukKerjasamaSagaUpdateBentukKerjasama)]);

  // jenis lembaga sagas
  yield all([fork(jenisLembagaSagaGetJenisLembaga)]);
  yield all([fork(jenisLembagaSagaCreateJenisLembaga)]);
  yield all([fork(jenisLembagaSagaUpdateJenisLembaga)]);
  yield all([fork(jenisLembagaSagaGetDetailJenisLembaga)]);

  // jenis dokumen sagas
  yield all([fork(jenisDokumenSagaGetJenisDokumen)]);
  yield all([fork(jenisDokumenSagaUpdateJenisDokumen)]);
  yield all([fork(jenisDokumenSagaCreateJenisDokumen)]);
  yield all([fork(jenisDokumenSagaGetDetailJenisDokumen)]);

  // status kerjasama sagas
  yield all([fork(statusKerjasamaSagaGetStatusKerjasama)]);
  yield all([fork(statusKerjasamaSagaUpdateStatusKerjasama)]);
  yield all([fork(statusKerjasamaSagaCreateStatusKerjasama)]);
  yield all([fork(statusKerjasamaSagaGetDetailStatusKerjasama)]);

  // partner sagas
  yield all([fork(partnerSagaGetPartner)]);
  yield all([fork(partnerSagaUpdatePartner)]);
  yield all([fork(partnerSagaCreatePartner)]);
  yield all([fork(partnerSagaGetDetailPartner)]);

  // user roles sagas
  yield all([fork(userRoleSagaGetRoles)]);
  yield all([fork(userRoleSagaSaveRole)]);
  yield all([fork(userRoleSagaCreateRole)]);
  yield all([fork(userRoleSagaGetDetailRoles)]);

  // user sagas
  yield all([fork(userSagaGetUser)]);
  yield all([fork(userSagaCreateUser)]);
  yield all([fork(userSagaUpdateUser)]);
  yield all([fork(userSagaGetDetailUser)]);

  // sagas for umn view
  yield all([fork(negaraSagaGetNegara)]);
  yield all([fork(employeeSagaGetEmployee)]);
  yield all([fork(departmentSagaGetDepartment)]);

  // authorization sagas
  yield all([fork(authorizationSagaGetUser)]);
}
